"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _localization = _interopRequireDefault(require("../components/localization"));

var getTranslations = function getTranslations(translations) {
  if (!translations) {
    var translationKeys = typeof window !== "undefined" && window.runtimeTranslations;
    return translationKeys;
  }

  return translations;
};

var RuntimeLocalizationContainer = function RuntimeLocalizationContainer(_ref) {
  var retrieving = _ref.retrieving,
      error = _ref.error,
      translations = _ref.translations,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["retrieving", "error", "translations"]);
  var translationKeys = getTranslations(translations);
  return /*#__PURE__*/_react["default"].createElement(_localization["default"], (0, _extends2["default"])({
    retrieving: false,
    translationKeys: translationKeys,
    error: null
  }, restProps));
};

RuntimeLocalizationContainer.propTypes = {
  retrieving: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  translations: _propTypes["default"].object
};
var _default = RuntimeLocalizationContainer;
exports["default"] = _default;